import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ActivitiesEffects } from './+state/activities.effects';
import { ActivitiesFacade } from './+state/activities.facade';
import * as fromActivities from './+state/activities.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromActivities.ACTIVITIES_FEATURE_KEY, fromActivities.reducer),
    EffectsModule.forFeature([ActivitiesEffects]),
  ],
  providers: [ActivitiesFacade],
})
export class OnmatStoreTeacherActivitiesModule {}
